import { Stack, Typography } from '@mui/material';

import { Mask } from '@hapvida/hapvida-core-components';

import { PartnerCompanyStatusChip } from '@flows/private/partnerCompanies/pages/PartnerCompanyList/components/PartnerCompaniesStatusChip';
import { useAuth } from '@hooks';

import type { GetRowListProps } from './types';
import { LinkRedirect } from '../components/PartnerCompanySummaryMobile/styles';

export const getRowList = ({ handleCompanyListRedirect }: GetRowListProps) => {
  const { currentCompany } = useAuth();
  const {
    document = '',
    tradeName,
    legal,
    status,
    paymentDay,
    cutoffDate,
  } = currentCompany ?? {};

  return [
    {
      label: 'Nome fantasia',
      xs: 3,
      value: <Typography variant="text">{tradeName}</Typography>,
    },
    {
      label: 'Razão social',
      xs: 3,
      value: <Typography variant="text">{legal}</Typography>,
    },
    {
      label: 'CNPJ',
      xs: 3,
      value: (
        <Typography variant="text">{Mask.cnpj(document, true)}</Typography>
      ),
    },
    {
      label: '',
      xs: 3,
      value: <></>,
    },
    {
      label: 'Data corte',
      xs: 3,
      value: <Typography variant="text">{cutoffDate ?? '-'}</Typography>,
    },
    {
      label: 'Data de vencimento',
      xs: 3,
      value: <Typography variant="text">{paymentDay ?? '-'}</Typography>,
    },
    {
      label: 'Status do contrato',
      xs: 3,
      value: (
        <>
          {status && (
            <PartnerCompanyStatusChip
              fontSize="12px"
              status={status}
              size="small"
            />
          )}
        </>
      ),
    },
    {
      label: 'Unidades neste contrato',
      xs: 3,
      value: (
        <Stack flexDirection="row" gap={1}>
          <LinkRedirect variant="text" onClick={handleCompanyListRedirect}>
            Mostrar detalhes
          </LinkRedirect>
        </Stack>
      ),
    },
  ];
};
